import { render, staticRenderFns } from "./ClockStatusOverlay.vue?vue&type=template&id=09bc0918&scoped=true&"
import script from "./ClockStatusOverlay.vue?vue&type=script&lang=js&"
export * from "./ClockStatusOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ClockStatusOverlay.vue?vue&type=style&index=0&id=09bc0918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc0918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
